import { pipe, prop } from 'ramda'
import { Policy } from './types'
import { getBenefitData } from './getBenefitData'

/**
 * V2 version of getBenefitUsedValue() util function. Retrieves the amount of
 * benefit used for a specific benefit type from a policy
 *
 * @example
 *   ;```typescript
 *   const policy = {
 *     benefitInfo: [{
 *       current: true,
 *       benefits: [{ benefitType: 'DEDUCTIBLE', used: 500 }]
 *     }]
 *   }
 *   const usedAmount = getBenefitUsedValue(policy, 'DEDUCTIBLE') // returns 500
 *   ```
 *
 * @param policy - The insurance policy object containing benefit information
 * @param benefitType - The type of benefit to check (e.g., 'DEDUCTIBLE',
 *   'MAX_ALLOWANCE')
 * @returns The amount of benefit used if the benefit exists, otherwise returns
 *   undefined
 */
export const getBenefitUsed = (
  policy: Policy | null | undefined,
  benefitType: string,
): number | undefined => {
  const benefitUsed = pipe(
    // First get the benefit data
    (p: Policy | null | undefined, bt: string) => getBenefitData(p, bt),
    // Then extract the used property, which will be undefined if benefit is undefined
    prop('used'),
  )

  return benefitUsed(policy, benefitType)
}
